// Primaries
export const COLOR_BLUE = "#1f6bff";

export const COLOR_SURFACE_CONTAINER = "#faf9f6";
export const COLOR_SURFACE_CONTAINER_STRONG = "#f4f4f1";
export const COLOR_SURFACE_CONTAINER_DARK = "#1a1a1a";
export const COLOR_SURFACE_CONTAINER_ALPHA = "#00000008";
export const COLOR_TEXT_PRIMARY = "#0a0907";
export const COLOR_TEXT_PRIMARY_HOVER = "#3d3a36";
export const COLOR_TEXT_SECONDARY = "#545454";
export const COLOR_TEXT_TERTIARY = "#888888";
export const COLOR_PLAY_BUTTON = "#2e2a28";
export const COLOR_GEM_STICKER = "#5d43e1";
export const COLOR_GEM_STICKER_BACKGROUND = "#eeebfb";
export const COLOR_GEM_STICKER_GEM = "#492fcd";
export const COLOR_GEM_STICKER_GEM_FACET = "#cdc4fd";

export const COLOR_ELEVATION_SHADOW = "#00000014";

export const COLOR_BORDER_DEFAULT = "rgba(0, 0, 0, 0.4)";
export const COLOR_NEUTRAL_BORDER = "#ebebeb"
export const COLOR_NEUTRAL_PROGRESS = "#666666"

export const COLOR_LINK = COLOR_TEXT_PRIMARY;


// Nav
export const COLOR_NAV_LINK_ACTIVE = COLOR_TEXT_PRIMARY;
export const COLOR_TAB_ICON_UNSELECTED = "#000000ab";
export const COLOR_MENU_SURFACE = "#e3e3e3eb";
export const COLOR_MENU_HOVER = "#0000000f";
export const COLOR_MENU_DIVIDER = "#00000014";


// Status
export const COLOR_GREEN = "#27ae60";
export const COLOR_GREEN_BORDER = "#259c57";
export const COLOR_GREEN_LIGHT = "#99e8ba";
export const COLOR_SUCCESS = "#139707";
export const COLOR_RED = "#eb5757";
export const COLOR_RED_LOGIN = "#d32f2f";
export const COLOR_RED_BRIGHT = "#ff0000";
export const COLOR_YELLOW_WARNING = "#f2c94b";

// Content type backgrounds
export const COLOR_FLASHCARD_YELLOW = "#ffe765";

// Purple / gem / premium
export const COLOR_PURPLE_DARK = "#6d00cb";
export const COLOR_PURPLE_DEEP = "#2e00e4";
export const COLOR_PURPLE_BRIGHT = "#9e3dff";

// Highlight / gradient
export const COLOR_HOT_PINK = "#ff0099";
export const COLOR_GOLD = "#ffc700";
export const COLOR_YELLOW_MILESTONE = "#ffe600";
export const COLOR_PAYWALL_HIGHLIGHT = "#ff385c";

// Grays (lightest to darkest)
export const COLOR_WHITE = "#ffffff";
export const COLOR_GRAY_100 = "#f8f9fa";
export const COLOR_GRAY_50 = "#f2f2f2";
export const COLOR_GRAY_F1 = "#f1f1f1";
export const COLOR_GRAY_EE = "#eeeeee";
export const COLOR_GRAY_DD = "#dddddd";
export const COLOR_GRAY_E8 = "#e8e8e8";
export const COLOR_GRAY_BORDER = "#e0e0e0";
export const COLOR_GRAY_D3 = "#d3d4d5";
export const COLOR_GRAY_D8 = "#d8d6d6";
export const COLOR_GRAY_DISABLED = "#bdbdbd";
export const COLOR_GRAY_INACTIVE = "#c4c4c4";
export const COLOR_GRAY_CC = "#cccccc";
export const COLOR_GRAY_77 = "#777777";
export const COLOR_GRAY_MUTED = "#828282";
export const COLOR_GRAY_88 = "#888888";
export const COLOR_GRAY_99 = "#999999";
export const COLOR_GRAY_55 = "#555555";
export const COLOR_GRAY_66 = "#666666";
export const COLOR_GRAY_4F = "#4f4f4f";
export const COLOR_GRAY_33 = "#333333";
export const COLOR_BLACK = "#000000";

// Special backgrounds
export const COLOR_IMAGE_OVERLAY = "#21212140";
export const COLOR_SHADOW_OVERLAY = "#00000026";
export const COLOR_SHADOW_LIGHT = "#0000001f";

// Semi-transparent whites
export const COLOR_WHITE_ALPHA_40 = "#ffffff66";
export const COLOR_WHITE_ALPHA_75 = "#ffffffbf";
export const COLOR_WHITE_ALPHA_95 = "#fffffff2";
